<template>
  <div>
    <div class="all-categories mb-20">
      <strong>{{ $t("profile.show.contactMe") }}</strong>
    </div>
    <form>
      <form-error :errors='errors' :attribute="'body'">
        <textarea v-model="message.body" class="form-control" rows="8" :placeholder="$t('profile.show.contactTextarea')"></textarea>
      </form-error>
      <button @click="sendMessage()" type="button" class="btn btn-default btn-lg button-wide-crowd">{{ $t("profile.show.sendButton") }}</button>
    </form>
    <alert :success="alert.success"></alert>
  </div>
</template>

<script>
// API
import userApi from '@/api/v1/user';
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import alert from '@/mixins/alert';

export default {
  props: ['user'],
  mixins: [alert],
  components: { Alert, FormError },
  data() {
    return {
      message: {
        user_id: this.user.id,
      },
    };
  },
  methods: {
    sendMessage() {
      const vm = this;
      this.clearAlerts();
      userApi.sendMessage(this.message).then((response) => {
        this.alert.success = response.data.status;
        setTimeout(() => { this.alert.success = null; }, 5000);
      }).catch((response) => {
        vm.errors = { body: response.response.data.errors };
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Contact.vue?fee46324